module.exports = "https://r.zoocdn.com/_next/static/images/person-advising-other-person@2x-5aa8431aaf317f4be97cc4246d301509.jpg";